import React from 'react';
import { Formik } from 'formik';
import { useParams } from 'react-router-dom';

import FormWrapper from '~FormWrapper';
import GenericSupportForm from './GenericSupportForm';

import { useOnSubmit } from '~hooks/useOnSubmit';
import { useOnEdit } from '~hooks/useOnEdit';
import { isPhoneNumberValid, removeEmptyKeys } from '../validations';

const validate = values => {
  const errors = {};

  if (!values.type) {
    errors.type = 'Vaadittu';
  }

  if (!values.topic) {
    errors.topic = 'Vaadittu';
  }

  if (values.type === 'HÄIRIÖ' && !values.problemDescription) {
    errors.problemDescription = 'Vaadittu';
  }

  if (values.type === 'PALVELUPYYNTÖ' && !values.additionalInfo) {
    errors.additionalInfo = 'Vaadittu';
  }

  if (!values.officeOfIncident) {
    errors.officeOfIncident = 'Vaadittu';
  }

  if (!values.placeOfIncident) {
    errors.placeOfIncident = 'Vaadittu';
  }

  if (values.customerIsNotNotifier && !values.contactEmail) {
    errors.contactEmail = 'Vaadittu';
  }

  errors.contactPhone = isPhoneNumberValid(values.contactPhone);

  return removeEmptyKeys(errors);
};

const GenericSupport = props => {
  const { formId, edit } = props;
  const { orderId } = useParams();

  const onFormSubmit = useOnSubmit();
  const onFormEdit = useOnEdit();

  return (
    <Formik
      initialValues={{
        type: null,
        topic: '',
        problemDescription: '',
        officeOfIncident: null,
        placeOfIncident: '',
        customerIsNotNotifier: false,
        additionalInfo: '',
        contactPhone: '',
        contactEmail: '',
        identificationNumber: null,
        problemIsRepeatingWithAll: false,
        attachmentInput: [],
      }}
      validate={validate}
      onSubmit={async (values, { setSubmitting }) => {
        setSubmitting(true);
        const method = edit ? onFormEdit : onFormSubmit;
        await method({
          fields: {
            ...values,
            officeOfIncident: values.officeOfIncident?.value,
            identificationNumber: values.identificationNumber?.value,
            attachmentInput: values.attachmentInput.map(a => ({ id: a.id })),
          },
          setSubmitting,
          orderId,
          formId,
        });
      }}
    >
      {formikProps => (
        <FormWrapper
          {...props}
          title="Käyttötuki"
          formik={formikProps}
          Component={GenericSupportForm}
        />
      )}
    </Formik>
  );
};

export default GenericSupport;
